import React from 'react';

import { Box, Typography } from '@mui/material';

interface Props {
  title: string;
  caption?: string;
  children: React.ReactNode;
}

/** One titled block in the ticket detail dialog, so every section reads the same. */
export default function TicketDetailSection({ title, caption, children }: Props) {
  return (
    <Box component="section">
      <Typography variant="subtitle2" fontWeight={700}>
        {title}
      </Typography>
      {caption && (
        <Typography variant="caption" color="text.secondary" component="p">
          {caption}
        </Typography>
      )}
      <Box sx={{ mt: 1.5 }}>{children}</Box>
    </Box>
  );
}
